import React from "react";
import OrgList from "./orgsList";
import { Switch, Route, useLocation, Redirect } from "react-router";
import Teams from "./teams";
import Environment from "./environment";
import Theme from "./theme";
import UserList from './users'
import Policy from './policy'
import AuditHistory from './auditHistory'
import { useSelector } from 'react-redux'
import NoData from '../apps/NoData'
import RedirectRoute from '../../helpers/RedirectRoute';
import { accessParam } from "../../helpers/commonFunction";
import { ReactComponent as WarningIcon } from '../../assets/svg/warningIcon.svg'
import { AppState } from "../../stateManager/store";
import { Downloads } from "./downloads";

const Organization: React.FC = props => {
  const selectedOrgId = useSelector((state: AppState) => state.org.selectedOrg && state.org.selectedOrg.id);
  const orgPermissions: any = useSelector((state: AppState) => {
    return state.org.orgPermissions
  }, (oldPermissions: any, newPermissions: any) => JSON.stringify(oldPermissions) === JSON.stringify(newPermissions))

  //Currently viewing orgs should be enbled by default.
  //Change it in future if control is required 
  const canViewOrganization = orgPermissions.includes('org.View') || true

  const location = useLocation();
  const redirectRouteProps = {
    matchId: accessParam(location.pathname, 1),
    selectorFn(state: AppState) {
      return state.org.orgList || []
    },
    resourceField: "id",
    navigateTo: `/organization/${selectedOrgId}/teams`,
    buttonText: "Visit organization",
    message: "The URL that you are trying to visit contains invalid orgId. It may have been removed or temporarily unavailable."
  }

  return (
    canViewOrganization ?
    <Switch>
      <Route exact path={["/organization"]} component={OrgList} />
      <RedirectRoute path={"/organization/:orgId/themeManager"} component={Theme} {...redirectRouteProps} />
      <RedirectRoute path={"/organization/:orgId/teams"} component={Teams} {...redirectRouteProps} />
      <RedirectRoute exact path={"/organization/:orgId/env"} component={Environment} {...redirectRouteProps} />
      <RedirectRoute exact path={"/organization/:orgId/users"} component={UserList} {...redirectRouteProps} />
      <RedirectRoute exact path={"/organization/:orgId/policy"} component={Policy} {...redirectRouteProps} />
      <RedirectRoute exact path={"/organization/:orgId/audit"} component={AuditHistory} {...redirectRouteProps}/>
      <RedirectRoute exact path={"/organization/:orgId/downloads"} component={Downloads} {...redirectRouteProps}/>
      <Route component={() => <Redirect to='/404' />}/>
    </Switch>
    :
    <NoData 
      svg={WarningIcon}
      header='Not Authorized'
      content='Please request owner of this organization to provide access' 
      noButton={true}
    />
  );
};

export default Organization;
